export const campaignDetailPageStyles = {
  topDivider: {
    height: 2,
    margin: '0 -14px 8px',
    background: 'linear-gradient(90deg, rgba(111,115,246,0.46) 0%, rgba(111,115,246,0.18) 56%, rgba(111,115,246,0) 100%)',
  } as const,
  sectionTitleRow: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 7,
    marginBottom: 10,
  } as const,
  sectionTitleBar: {
    width: 4,
    height: 20,
    borderRadius: 999,
    background: 'linear-gradient(180deg, #6d74f3 0%, #8e7ef7 100%)',
  } as const,
  sectionTitle: {
    fontSize: 15,
    lineHeight: 1.2,
    fontWeight: 800,
    color: '#202437',
  } as const,
  sectionCard: {
    borderRadius: 18,
    background: '#ffffff',
    border: '1px solid rgba(233, 236, 244, 0.96)',
    boxShadow: '0 10px 22px rgba(82, 88, 110, 0.06)',
    padding: '14px 14px 16px',
  } as const,
  headerTags: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    flexWrap: 'wrap',
    marginBottom: 12,
  } as const,
  headerTag: {
    fontSize: 12,
    lineHeight: 1.2,
    fontWeight: 800,
    color: '#2a2f3a',
  } as const,
  verifiedTag: {
    marginLeft: 'auto',
    padding: '5px 8px',
    borderRadius: 999,
    fontSize: 11,
    lineHeight: 1,
    fontWeight: 800,
    letterSpacing: '0.06em',
    border: '1px solid transparent',
  } as const,
  verifiedTagSuccess: {
    color: '#404349',
    background: '#f3f4f7',
    borderColor: '#e6e8ee',
  } as const,
  verifiedTagMuted: {
    color: '#a16118',
    background: '#fff4e5',
    borderColor: '#ffe0b2',
  } as const,
  accountPanel: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '14px 12px',
    borderRadius: 16,
    border: '1px solid rgba(221, 225, 236, 0.96)',
    background: '#ffffff',
  } as const,
  accountAvatar: {
    width: 52,
    height: 52,
    borderRadius: 16,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  } as const,
  accountContent: {
    minWidth: 0,
    flex: 1,
  } as const,
  accountStatusCard: {
    borderRadius: 20,
    padding: '16px 16px 14px',
    background: 'linear-gradient(180deg, rgba(244, 247, 255, 0.92) 0%, rgba(255, 255, 255, 0.98) 100%)',
    border: '1px solid rgba(66, 133, 244, 0.10)',
    boxShadow: '0 14px 32px rgba(82, 88, 110, 0.07)',
  } as const,
  accountHeaderLabel: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 0.2,
    color: '#7f879b',
  } as const,
  accountHeaderValue: {
    marginTop: 4,
    fontSize: 15,
    fontWeight: 800,
    color: '#202437',
    wordBreak: 'break-all',
  } as const,
  accountAlias: {
    marginTop: 6,
    fontSize: 12,
    lineHeight: 1.3,
    color: '#6d74f3',
    fontWeight: 700,
  } as const,
  accountTag: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '3px 9px',
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 700,
  } as const,
  switchButton: {
    height: 34,
    padding: '0 14px',
    borderRadius: 999,
    border: '1.5px solid rgba(109, 116, 243, 0.5)',
    color: '#6d74f3',
    background: '#ffffff',
    fontWeight: 800,
    fontSize: 13,
    flexShrink: 0,
  } as const,
  connectionPanel: {
    marginTop: 16,
    borderRadius: 16,
    padding: '14px 12px 12px',
    border: '1px solid rgba(198, 204, 255, 0.88)',
    background: 'linear-gradient(180deg, rgba(244,245,255,0.96) 0%, rgba(239,241,255,0.9) 100%)',
    boxShadow: '0 10px 18px rgba(109, 116, 243, 0.08)',
  } as const,
  connectionTopRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12,
  } as const,
  statePanel: {
    borderRadius: 16,
    padding: '12px 14px',
    border: '1px solid rgba(66, 133, 244, 0.10)',
    background: 'rgba(66, 133, 244, 0.05)',
  } as const,
  stateTitle: {
    fontSize: 13,
    fontWeight: 800,
    color: '#5666f1',
  } as const,
  stateHint: {
    marginTop: 6,
    fontSize: 12,
    lineHeight: 1.6,
    color: '#667085',
  } as const,
  connectionTagBase: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 24,
    padding: '0 10px',
    borderRadius: 999,
    fontSize: 12,
    lineHeight: 1,
    fontWeight: 800,
    border: '1px solid transparent',
    whiteSpace: 'nowrap',
  } as const,
  connectionTagReady: {
    color: '#0f9f5f',
    background: '#ebfff5',
    borderColor: '#c7f0db',
  } as const,
  connectionTagBlocked: {
    color: '#ff5a6b',
    background: '#fff1f4',
    borderColor: '#ffd4dc',
  } as const,
  connectionTagLoading: {
    color: '#6d74f3',
    background: '#eef1ff',
    borderColor: '#d9defe',
  } as const,
  connectButton: {
    marginTop: 14,
    height: 42,
    borderRadius: 999,
    border: 'none',
    background: 'linear-gradient(90deg, #6d74f3 0%, #5865f0 100%)',
    color: '#ffffff',
    fontWeight: 800,
    fontSize: 15,
    boxShadow: '0 10px 18px rgba(95, 102, 246, 0.2)',
  } as const,
  connectButtonInner: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
  } as const,
  progressPanel: {
    marginTop: 16,
    borderRadius: 16,
    padding: '14px 12px 12px',
    border: '1px solid rgba(233, 236, 244, 0.96)',
    background: '#ffffff',
  } as const,
  progressTitle: {
    fontSize: 14,
    lineHeight: 1.2,
    fontWeight: 800,
    color: '#202437',
  } as const,
  progressSummary: {
    marginTop: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    fontSize: 13,
    lineHeight: 1.4,
    color: '#727a8c',
    fontWeight: 700,
  } as const,
  progressRemain: {
    color: '#6d74f3',
    flexShrink: 0,
  } as const,
  progressTrack: {
    marginTop: 10,
    width: '100%',
    height: 8,
    borderRadius: 999,
    background: '#eceef4',
    overflow: 'hidden',
  } as const,
  progressFill: {
    height: '100%',
    borderRadius: 999,
    background: 'linear-gradient(90deg, #6d74f3 0%, #8392ff 100%)',
  } as const,
  stateMeta: {
    marginTop: 8,
    fontSize: 12,
    color: '#98a2b3',
  } as const,
  accountProgressCard: {
    borderRadius: 16,
    padding: '12px 14px',
    border: '1px solid rgba(32, 36, 55, 0.06)',
    background: '#ffffff',
  } as const,
  summaryLabel: {
    fontSize: 12,
    color: '#8c8c8c',
    marginBottom: 4,
  },
  summaryValue: {
    fontSize: 14,
    color: '#1f1f1f',
    lineHeight: '22px',
  },
  contentBox: {
    position: 'relative',
    background: '#ffffff',
    borderRadius: 16,
    padding: '18px 14px 14px',
    border: '1px solid rgba(231, 236, 246, 0.9)',
    boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.6)',
  } as const,
  contentLabelBadge: {
    position: 'absolute',
    top: '-10px',
    left: '12px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    padding: '4px 8px',
    borderRadius: 8,
    background: '#ffffff',
    border: '1px solid rgba(229, 233, 243, 0.96)',
    color: '#7f879b',
    fontSize: 11,
    lineHeight: 1,
    fontWeight: 700,
  } as const,
  sendContentCard: {
    borderRadius: 18,
    background: '#ffffff',
    border: '1px solid rgba(233, 236, 244, 0.96)',
    boxShadow: '0 10px 22px rgba(82, 88, 110, 0.06)',
    padding: '14px 14px 12px',
  } as const,
  templatesWrap: {
    display: 'grid',
    gap: 12,
  } as const,
  mediaPreview: {
    marginBottom: 10,
    padding: 6,
    borderRadius: 14,
    background: '#f8fafc',
    border: '1px solid rgba(231, 236, 246, 0.9)',
  } as const,
  mediaImage: {
    width: '100%',
    maxHeight: 220,
    borderRadius: 14,
    objectFit: 'cover',
    display: 'block',
  } as const,
  contentLabel: {
    marginBottom: 8,
    fontSize: 12,
    lineHeight: 1.4,
    color: '#8f95a3',
    fontWeight: 700,
  } as const,
  contentText: {
    whiteSpace: 'pre-wrap',
    fontSize: 15,
    lineHeight: 1.65,
    color: '#1f2433',
    wordBreak: 'break-word',
  } as const,
  forwardButton: {
    marginTop: 12,
    height: 44,
    borderRadius: 999,
    fontSize: 15,
    fontWeight: 800,
    boxShadow: '0 10px 20px rgba(95, 102, 246, 0.18)',
    background: 'linear-gradient(90deg, #6d74f3 0%, #5865f0 100%)',
    border: 'none',
  } as const,
  resultCard: {
    borderRadius: 18,
    background: '#ffffff',
    border: '1px solid rgba(233, 236, 244, 0.96)',
    boxShadow: '0 10px 22px rgba(82, 88, 110, 0.06)',
    padding: '14px 14px 16px',
    minHeight: 196,
  } as const,
  batchCard: {
    borderRadius: 18,
    background: '#ffffff',
    border: '1px solid rgba(233, 236, 244, 0.96)',
    boxShadow: '0 10px 22px rgba(82, 88, 110, 0.06)',
    padding: '14px 14px 16px',
    minHeight: 88,
  } as const,
  batchLoading: {
    minHeight: 72,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  } as const,
  batchEmpty: {
    minHeight: 72,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    color: '#98a0b1',
    fontSize: 13,
    fontWeight: 700,
  } as const,
  batchList: {
    display: 'grid',
    gap: 10,
  } as const,
  batchItem: {
    borderRadius: 14,
    padding: '12px',
    background: '#f8f9fc',
    border: '1px solid rgba(234, 237, 244, 0.96)',
  } as const,
  batchHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  } as const,
  batchStatus: {
    fontSize: 14,
    lineHeight: 1.3,
    fontWeight: 800,
    color: '#202437',
  } as const,
  batchProgressText: {
    flexShrink: 0,
    fontSize: 12,
    lineHeight: 1,
    fontWeight: 800,
    color: '#6d74f3',
  } as const,
  batchMetricGrid: {
    marginTop: 10,
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: 8,
    fontSize: 11,
    lineHeight: 1.35,
    color: '#7f879b',
    fontWeight: 700,
  } as const,
  batchTrack: {
    marginTop: 10,
    width: '100%',
    height: 8,
    borderRadius: 999,
    background: '#eceef4',
    overflow: 'hidden',
  } as const,
  batchFill: {
    height: '100%',
    borderRadius: 999,
    background: 'linear-gradient(90deg, #6d74f3 0%, #36c486 100%)',
  } as const,
  batchTimeRow: {
    marginTop: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
    flexWrap: 'wrap',
    fontSize: 11,
    lineHeight: 1.4,
    color: '#98a2b3',
    fontWeight: 600,
  } as const,
  batchCancelButton: {
    marginTop: 10,
    height: 34,
    borderRadius: 999,
    fontWeight: 800,
  } as const,
  resultLoading: {
    minHeight: 164,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  } as const,
  emptyResult: {
    minHeight: 164,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    color: '#98a0b1',
  } as const,
  emptyResultIcon: {
    marginBottom: 12,
  } as const,
  emptyResultTitle: {
    fontSize: 18,
    lineHeight: 1.25,
    fontWeight: 800,
    color: '#1f2430',
  } as const,
  emptyResultHint: {
    marginTop: 8,
    fontSize: 12,
    lineHeight: 1.55,
    color: '#a0a7b7',
    fontWeight: 600,
  } as const,
  receiptList: {
    display: 'grid',
    gap: 10,
  } as const,
  receiptCard: {
    borderRadius: 14,
    padding: '12px 12px 10px',
    background: '#f8f9fc',
    border: '1px solid rgba(234, 237, 244, 0.96)',
  } as const,
  receiptHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    marginBottom: 8,
  } as const,
  receiptNumber: {
    fontSize: 14,
    lineHeight: 1.3,
    fontWeight: 800,
    color: '#202437',
  } as const,
  receiptStatus: {
    flexShrink: 0,
    padding: '4px 8px',
    borderRadius: 999,
    background: '#eef1ff',
    color: '#6d74f3',
    fontSize: 11,
    lineHeight: 1,
    fontWeight: 800,
    textTransform: 'uppercase',
  } as const,
  receiptMeta: {
    fontSize: 12,
    lineHeight: 1.55,
    color: '#81889a',
    fontWeight: 600,
  } as const,
  receiptError: {
    marginTop: 4,
    fontSize: 12,
    lineHeight: 1.5,
    color: '#d63f3f',
    fontWeight: 600,
  } as const,
  emptySimpleCard: {
    borderRadius: 18,
    background: '#ffffff',
    border: '1px solid rgba(233, 236, 244, 0.96)',
    boxShadow: '0 10px 22px rgba(82, 88, 110, 0.06)',
    padding: '24px 14px',
    textAlign: 'center',
    color: '#8f95a3',
    fontWeight: 600,
  } as const,
};
